// extracted by mini-css-extract-plugin
export var sectionWrapper = "SectionWrapper-module--sectionWrapper--4d065";